import React from 'react';
import * as S from './style';
import { LinkStyled } from '../../../pages/login/style';

const introText =
  'A Fundacred valoriza a segurança dos seus dados pessoais. Ao fornecê-los, você concorda com nossa ';
const separator = ' e ';
const andSeparator = '. Acesse também o ';

function LgpdLogin(): JSX.Element {
  return (
    <S.DivLgpd>
      <S.LgpdStyled>
        {introText}
        <LinkStyled
          href="https://fundacred.org.br/aviso-de-privacidade/"
          rel="noopener noreferrer"
          target="_blank"
        >
          Política de Privacidade
        </LinkStyled>
        {separator}
        <LinkStyled
          href="https://fundacred.org.br/politica-de-cookies/"
          rel="noopener noreferrer"
          target="_blank"
        >
          Política de Cookies
        </LinkStyled>
        {andSeparator}
        <LinkStyled
          href="https://fundacred.org.br/codigo-conduta/"
          rel="noopener noreferrer"
          target="_blank"
        >
          Código de Conduta para Terceiros
        </LinkStyled>
        .
      </S.LgpdStyled>
    </S.DivLgpd>
  );
}

export default LgpdLogin;
